import React from "react";

import { Grid } from "@mui/material";
import { wallets, BUYER } from "../constants";

import "../styles.css";

export const options: any = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
};

const ReleaseToSeller = (props: any) => {
  const { type, transactionsInfo } = props;

  return (
    <>
      <>
        <Grid
          item
          md={2}
          sx={{ display: { xs: "none", sm: "block" } }}
          className="trans-center">
          <span className="trans-amount-red">
            -{transactionsInfo.amount + " " + wallets.SAR}
          </span>
        </Grid>
        <Grid item md={6} xl={6} sx={{ display: { xs: "block", sm: "block" } }}>
          <div className="trans-title">
            {type === BUYER
              ? wallets.PAYMENT_RELASE_BUYER
              : transactionsInfo.beneficiaryName}
            <span className="trans-title-name">
              {type === BUYER
                ? transactionsInfo.beneficiaryName
                : wallets.SELLER_PAYMENT_RELASE_BUYER}
            </span>
          </div>

          <div className="trans-sub">
            {type === BUYER
              ? wallets.PAYMENT_RELASE_BUYER_SUB
              : wallets.SELLER_PAYMENT_RELASE_BUYER_SUB}
          </div>
        </Grid>
      </>
    </>
  );
};
export default ReleaseToSeller;
